import API from "@/services/api";
import router from "@/router";

export default {
  fetchStudentsExport() {
    return API().get("students");
  },
  fetchStudents() {
    return API().get("table/students");
  },
  fetchCoordinatorStudents(id) {
    return API().get(`coordaintors/${id}/students`);
  },
  fetchTrainerStudents(id) {
    return API().get(`trainers/${id}/students`);
  },
  addStudent(params) {
    return API().post("students", params);
  },
  updateStudent(params) {
    return API().put(`students/${router.currentRoute.params.id}`, params);
  },
  updateStudentActive(params) {
    return API().put(`students/${params.uuid}`, params);
  },
  updateStudentDuplicate(params) {
    return API().put(`students/${params.uuid}`, params);
  },
  getStudent() {
    return API().get(`students/${router.currentRoute.params.id}`);
  },
  fetchStudentAttendances() {
    return API().get(`students/${router.currentRoute.params.id}/attendances`);
  },
  addStudentAttendances(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/attendances`,
      params
    );
  },
  updateStudentAttendances(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/attendances`,
      params
    );
  },
  deleteStudentAttendances(studentAttendanceId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/attendances`,
      studentAttendanceId
    );
  },
  fetchStudentTrackings() {
    return API().get(`students/${router.currentRoute.params.id}/trackings`);
  },
  addStudentTrackings(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/trackings`,
      params
    );
  },
  updateStudentTrackings(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/trackings`,
      params
    );
  },
  deleteStudentTrackings(studentTrackingId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/trackings`,
      studentTrackingId
    );
  },
  fetchStudentDropouts() {
    return API().get(`students/${router.currentRoute.params.id}/dropouts`);
  },
  addStudentDropouts(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/dropouts`,
      params
    );
  },
  updateStudentDropouts(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/dropouts`,
      params
    );
  },
  deleteStudentDropouts(studentDropoutId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/dropouts`,
      studentDropoutId
    );
  },
  fetchAllStudentSchoolReady() {
    return API().get(`students/${router.currentRoute.params.id}/school-ready`);
  },
  fetchOneStudentSchoolReady(params) {
    return API().get(
      `students/${router.currentRoute.params.id}/school-ready/${params}`
    );
  },
  addStudentSchoolReady(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/school-ready`,
      params
    );
  },
  updateStudentSchoolReady(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/school-ready`,
      params
    );
  },
  deleteStudentSchoolReady(studentSchoolReadyId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/school-ready`,
      studentSchoolReadyId
    );
  },
  fetchStudentFeedings() {
    return API().get(`students/${router.currentRoute.params.id}/feedings`);
  },
  addStudentFeedings(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/feedings`,
      params
    );
  },
  updateStudentFeedings(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/feedings`,
      params
    );
  },
  deleteStudentFeedings(studentFeedingId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/feedings`,
      studentFeedingId
    );
  },
  fetchStudentParents() {
    return API().get(`students/${router.currentRoute.params.id}/parents`);
  },
  addStudentParents(params) {
    return API().post(
      `students/${router.currentRoute.params.id}/parents`,
      params
    );
  },
  updateStudentParents(params) {
    return API().put(
      `students/${router.currentRoute.params.id}/parents`,
      params
    );
  },
  deleteStudentParents(studentParentId) {
    return API().delete(
      `students/${router.currentRoute.params.id}/parents`,
      studentParentId
    );
  },
  fetchStudentsBySchool(schoolId) {
    return API().get(`schools/${schoolId}/teachers-students`);
  },
  fetchStudentSchoolAndTeacher() {
    return API().get(
      `students/${router.currentRoute.params.id}/school-teacher`
    );
  },
  fetchStudentsByCountry(params) {
    return API().get(`students/country/${params.country}`);
  },
  fetchStudentsByCountryRegion(params) {
    return API().get(
      `students/country/${params.country}/region/${params.region}`
    );
  },
  fetchStudentsByCountryRegionDistrict(params) {
    return API().get(
      `students/country/${params.country}/region/${params.region}/district/${params.district}`
    );
  },
  fetchStudentsByCountryRegionDistrictVillage(params) {
    return API().get(
      `students/country/${params.country}/region/${params.region}/district/${params.district}/village/${params.village}`
    );
  },
  fetchStudentsByCountryVillage(params) {
    return API().get(
      `students/country/${params.country}/village/${params.village}`
    );
  },
  fetchStudentsByVillage(params) {
    return API().get(`students/village/${params.village}`);
  },
};
